import {
  GetLineTranscriptionsSettingsQuery,
  GetLineTranscriptionsSettingsQueryVariables,
} from "@/graphql/generated/graphql";
import { GetLineTranscriptionsSettings } from "@/graphql/queries/GetLineTranscriptionsSettings";
import { useQueryWrapper } from "@/hooks/useQueryWrapper/useQueryWrapper";
import { useBaseStore } from "@/store/store";
import { UseTranscriptionReturn } from "./useTranscriptionSettings.decl";

/**
 * Fetches line configuration, provide an object which has for entries,
 * Recording | Voicemail, and has for values boolean if they are activated.
 * @param lineId - id of the line
 * @returns an object holding the line configuration
 */
export function useTranscriptionSettings(
  lineId?: number | null
): UseTranscriptionReturn {
  const setTranscriptionSettings = useBaseStore(
    (store) => store.setTranscriptionSettings
  );

  const { data, loading } = useQueryWrapper<
    GetLineTranscriptionsSettingsQuery,
    GetLineTranscriptionsSettingsQueryVariables
  >(GetLineTranscriptionsSettings, {
    variables: {
      // We have to cast for TypeScript although since we skip if lineId is falsy, lineId here will always be a proper number if not skipped.
      lineId: Number(lineId),
    },
    onCompleted(data) {
      setTranscriptionSettings(data.getLineTranscriptionsSettings);
    },
    skip: !lineId,
  });

  return {
    loading,
    transcriptionSettings: data?.getLineTranscriptionsSettings,
  };
}
